import { render, staticRenderFns } from "./IdentityNumber.vue?vue&type=template&id=5fb79306&"
import script from "./IdentityNumber.vue?vue&type=script&lang=js&"
export * from "./IdentityNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports